import * as React from 'react';

import {ScrollableContainerWithShadow} from 'shells/layout/scrollable-container-with-shadow/scrollable-container-with-shadow';
import type {TimelineEntryIconVariant} from 'shells/timeline/gutter/types';
import type {ChangeType, EventType} from 'shells/timeline/types';

import type {
    EventFragmentSparse_actor as Actor,
    EmailInteractionFragmentFull as EmailInteraction,
    EmailFragmentFull as Email,
} from 'nutshell-graphql-types';

import {MarketingOutreachEmail} from './marketing-outreach-email';
import {RichTextareaEmail} from './rich-textarea-email';
import {TimelineBannerModalWrapper} from './timeline-banner-modal-wrapper';

type Props = {
    isOpen: boolean;
    isLoading: boolean;
    actor: Actor;
    entryType: EventType;
    changeType: ChangeType;
    timestamp: number;
    entity?: EmailInteraction | null | undefined | Email;
    iconVariant: TimelineEntryIconVariant;
    bodyHtml: string;
    onClose: () => void;
    isEdition?: boolean;
};

export function TimelineBannerModal(props: Props) {
    if (!props.isOpen) {
        return null;
    }

    return (
        <TimelineBannerModalWrapper
            isLoading={props.isLoading}
            onClose={props.onClose}
            iconVariant={props.iconVariant}
            timestamp={props.timestamp}
            actor={props.actor}
            entryType={props.entryType}
            // @ts-expect-error
            entity={props.entity}
            changeType={props.changeType}
        >
            <ScrollableContainerWithShadow
                direction='vertical'
                maxContainerSize={600}
                showReverseGradientShadow={true}
                gradientShadowSize={60}
            >
                {props.isEdition ? (
                    <MarketingOutreachEmail bodyHtml={props.bodyHtml} />
                ) : (
                    <RichTextareaEmail bodyHtml={props.bodyHtml} />
                )}
            </ScrollableContainerWithShadow>
        </TimelineBannerModalWrapper>
    );
}
